<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.category.name | translate }} - {{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("file-manager.file-upload") }}</span>
      </h2>
      <div v-if="!isNoDocumentNumberRequiredFile">
        <!-- <div v-if="!newFileNo && form && !form._id" class="mt-2">
          <label>{{ $t("file-manager.no") }}</label>

          <div class="d-flex flex-row">
            <div class="w-95 ">
              <filter-select id="no-filter" ref="no-filter" :placeholder="$t('file-manager.no')" :multiple="false" @filter="onNoSearch" :selected="form.no" @changed="noSelect" />
            </div>
            <div class="mt-1 ml-2" v-b-tooltip.hover :title="$t('file-manager.new-file-no')"><i class="iconoir-plus font-size-24 hand" @click="newFileNo = true"></i></div>
          </div>
        </div> -->
        <div>
          <div class="d-flex  flex-row">
            <div class="w-100">
              <sweet-input
                class="mt-1"
                :disabled="isEditMode"
                v-model="form.no"
                :isValid="!$v.form.no.$error"
                @input="$v.form.no.$touch()"
                layout="vertical"
                :placeholder="$t('file-manager.no')"
                :label="$t('file-manager.no')"
              />
            </div>

            <!-- <div v-if="form && !form._id" class="mt-2" v-b-tooltip.hover :title="$t('common.select')">
              <i class="bx bx-select-multiple font-size-24 hand mt-4 ml-2" @click="newFileNo = false"></i>
            </div> -->
          </div>
        </div>
        <!-- <p>{{ $t("file-manager.file-no-info") }}</p> -->
      </div>
      <sweet-input
        class="mt-3"
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('common.name')"
      />

      <h6 class="mt-3">{{ $t("file-manager.admin") }}</h6>
      <organization-member-select :selected="form.admin" @onSelect="onMemberSelect" :organization="currentOrganization" :filterFunction="filterFunction" />

      <label class="mt-3">{{ $t("product.text") }}</label>
      <b-form-tags v-model="form.products" size="lg" class="mb-2" @input="productSelect($event)" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="accessableProducts">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
          <b-form-text v-else>
            <span class="text-danger">{{ $t("product.required") }}</span>
          </b-form-text>
        </template>
      </b-form-tags>

      <label class="mt-2">{{ $t("file-manager.file-category.parent") }}</label>
      <filter-select
        id="parentCategoryFilter"
        ref="parentCategoryFilter"
        :placeholder="$t('file-manager.file-category.parent')"
        :multiple="false"
        @filter="onParentCategorySearch"
        :selected="form.parentCategory"
        @changed="parentCategorySelect"
        track="_id"
      />

      <div v-if="showChildCategory">
        <label class="mt-2">{{ $t("file-manager.file-category.text") }}</label>
        <i class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white" v-b-tooltip.hover :title="$t('file-manager.optional-category-info')"></i>
        <filter-select
          id="categoryFilter"
          ref="categoryFilter"
          :placeholder="$t('file-manager.file-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.category"
          @changed="categorySelect"
          track="_id"
        />
      </div>
      <!-- 
      <div class="d-flex flew-row">
        <div class="">
          <b-form-checkbox switch v-model="form.isPeriodical" :value="true" :unchecked-value="false" class="custom-checkbox  mt-4 ">
            {{ $t("file-manager.periodic-review") }}
          </b-form-checkbox>
        </div>
        <div class="">
          <span v-if="form.isPeriodical">
            <input class="form-control input-sm mt-3 ml-4" v-model="form.period" type="number" min="1" layout="vertical" :placeholder="$t('policy.period')" />
          </span>
        </div>
      </div> -->

      <file-rocket
        v-if="!isEditMode"
        ref="fileRocket"
        show-progress="Upload"
        :disabled="isUploadDisabled"
        class="mt-3"
        :allowedFormats="allowedFormats"
        @response="handleUploadResponse"
        :payload="this.form"
        :hidden="true"
        :maxFileSize="5242880"
      ></file-rocket>
      <br />
      <hr />
      <h4>{{ $t("file-manager.related-to") }}</h4>

      <!-- <div class="pcard--title" style="margin-bottom: 0.8rem;">
        <span
          class="add-button hand"
          @click="
            showNewRelationPanel = true;
            $forceUpdate();
          "
        >
          {{ $t("common.link-with") }}
          <i class="iconoir-plus font-size-24"></i>
        </span>
      </div> -->

      <div v-if="hasRelation" class="added-questions">
        <div v-if="true">
          <div
            class="d-flex flex-row justify-content-begin align-items-center card card-body"
            v-for="rel in Object.keys(form.entity).filter((x) => x != 'task' && this.form.entity[x] && this.form.entity[x].length > 0)"
            :key="rel"
          >
            <div v-if="disableEditRelation(rel)" class="disabled-pcard--actions w-10">
              <i class="iconoir-edit"></i>
              <i class="iconoir-trash"></i>
            </div>

            <div v-else class="pcard--actions w-10">
              <i class="iconoir-edit" @click="editRelation(rel)"></i>
              <i class="iconoir-trash" @click="removeRelation(rel)"></i>
            </div>

            <div class="w-20">
              <div>
                <select disabled class="form-control" :value="rel">
                  <option value="undefined" disabled>{{ $t("file-manager.related-to") }}</option>
                  <option value="question">{{ $t("question.text") }}</option>
                  <option value="questionSet">{{ $t("question-set.text") }}</option>
                  <option value="firm">{{ $t("firm.text") }}</option>
                </select>
              </div>
            </div>

            <div class="ml-4 w-60"><filter-select :disabled="true" :placeholder="$t('department.text')" :multiple="true" :selected="form.entity[rel]" /></div>
          </div>
        </div>
      </div>

      <sweet-button
        @click="save()"
        type="submit"
        :loading="isUpdating"
        :disabled="isUpdating || $v.$invalid || !isFileSelected"
        variant="success"
        icon="mdi mdi-check"
        size="sm"
        buttonClass="mt-2"
      >
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
import { required, requiredIf } from "vuelidate/lib/validators";
import FileRocket from "../../components/common/form/file-rocket.vue";

const state = "fileManager";

export default {
  props: ["scope", "closeOnSave"],
  components: { FileRocket, OrganizationMemberSelect },
  data() {
    return {
      newFileNo: false,
      relationType: undefined,
      selectedRelation: undefined,
      // initialPeriodicalStatus: false,
      showNewRelationPanel: false,
      showChildCategory: false,
      allowedFormats: ["application/*", "image/*", "text/*"],
      form: { name: undefined, no: undefined, category: undefined, products: undefined, entity: undefined, admin: undefined },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      parentCategory: {
        required,
        // requiredIf: requiredIf((form) => {
        //   return !!form.category;
        // }),
      },

      products: {
        required,
      },
      no: {
        requiredIf: requiredIf((form) => {
          const values = ["REPORT", "LEGAL_DOCUMENT", "INVENTORY", "APPLICATION"];
          return !values.includes(form?.directoryType);
        }),
      },
      admin: {
        required,
      },
    },
  },
  watch: {
    uploadedFiles: {
      deep: true,

      handler(v) {
        if (!v || (v && v.length == 0)) {
          if (this.closeOnSave) {
            // this.$root.$emit("bv::toggle::collapse", "sidebar-file-upload");
          }
        }
      },
    },

    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };

        if (this.form.category) {
          if (this.form.category.parent) {
            this.form.parentCategory = this.form.category.parent;
          } else {
            this.form.parentCategory = this.form.category;
            this.form.category = undefined;
          }
          this.showChildCategory = true;
          this.$refs?.categoryFilter?.reset();
        }
        // this.initialPeriodicalStatus = this.form.isPeriodical;
        this.$v.form.$touch();
        this.$forceUpdate();
      },
    },

    "form.products": {
      deep: true,

      handler(v) {
        // this.productSelect();
      },
    },
    "form.parentCategory._id": {
      handler(v) {
        if (v) {
          this.showChildCategory = true;
          this.$refs?.categoryFilter?.reset();
        } else {
          this.showChildCategory = false;
          this.form.category = undefined;
        }
      },
    },
  },
  computed: {
    isNoDocumentNumberRequiredFile() {
      const values = ["REPORT"];
      return values.includes(this.form?.directoryType);
    },
    filePagination() {
      return this.$store.getters[`fileManager/pagination`];
    },
    isFileSelected() {
      if (this.form._id) {
        return true;
      }

      const files = this.$refs?.fileRocket?.selectedFiles;
      if (files && files.length > 0) {
        return true;
      }
      return false;
    },
    hasRelation() {
      return this.form && this.form.entity && Object.values(this.form.entity).some((array) => array.length > 0);
    },
    isUploadDisabled() {
      return false; //TODO
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
    isUploading() {
      return this.$store.getters["fileManager/isUploading"];
    },

    selectedParentCategory() {
      return this.$store.getters["organizationFileCategory/selectedParentCategory"];
    },
    selectedSubCategory() {
      return this.$store.getters["organizationFileCategory/selectedCategory"];
    },
    uploadedFiles() {
      return this.$store.getters[`fileManager/uploadedFiles`];
    },
  },
  async mounted() {
    if ((!this.form.products && this.scope) || (this.form.products?.length == 0 && this.scope)) {
      this.form.products = [this.scope];
      this.productSelect();
    }
  },
  methods: {
    disableEditRelation(key) {
      // const values = ["LEGAL_DOCUMENT"];
      // return values.includes(this.form?.directoryType) && key == "legalDocument";
      return true;
    },
    productSelect() {
      this?.$refs?.["parentCategoryFilter"]?.reset();
      this?.$refs?.["categoryFilter"]?.reset();
    },
    async onNoSearch(value, callback) {
      const response = await this.$store.dispatch(`${state}/paginateFileForNos`, {
        options: { limit: 200 },
        query: {
          name: { value },
          no: { value: { $exists: true }, isObject: true },
          admin: { value: this.currentAccount._id, isObject: true },
          latest: { value: true, isObject: true },
        },
      });

      callback(response.data?.docs.map((i) => ({ name: { tr: i.no, en: i.no, de: i.no, fr: i.no } })) ?? []);
    },
    async noSelect(item) {
      if (!item) {
        this.form.no = undefined;
        return;
      }
      const response = await this.$store.dispatch(`${state}/paginateFileForNos`, {
        options: { limit: 200 },
        query: { no: { value: { $exists: true }, isObject: true } },
      });
      const file = response.data?.docs.find((i) => i.no == item.name.tr);

      // const file = this.filePagination?.docs.find((i) => i.no == item.name.tr);

      delete file._id;
      delete file.history;
      this.form = { ...this.prepareFormForEdit({ ...this.form, ...file }) };
      this.newFileNo = true;

      if (this.form.category) {
        if (this.form.category.parent) {
          this.form.parentCategory = this.form.category.parent;
        } else {
          this.form.parentCategory = this.form.category;
          this.form.category = undefined;
        }
        this.showChildCategory = true;
        this.$refs?.categoryFilter?.reset();
      }
      this.$v.form.$touch();
      this.$forceUpdate();
    },
    editRelation(relation) {
      this.showNewRelationPanel = true;
      this.relationType = relation;
      this.selectedRelation = this.form.entity[relation];
    },
    async removeRelation(relation) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      delete this.form?.entity?.[relation];
      this.$forceUpdate();
    },
    isRelationValid() {
      if (!this.relationType) {
        return false;
      }

      if (this.relationType == "policy") {
        //return !!this.form.entity?.policy;
        return !!this.selectedRelation;
      }
    },
    addRelation() {
      if (!this.relId) {
        this.relId = "id" + new Date().getTime();
      }

      this.form = {
        ...this.form,
        entity: {
          ...this.form.entity,

          [this.relationType]: this.selectedRelation,
        },
      };

      this.clearRelationForm();
    },
    clearRelationForm() {
      this.selectedRelation = undefined;
      this.relationType = undefined;

      this.showNewRelationPanel = false;
    },

    filterFunction(item) {
      const permissionFilter = new Set(["ORGANIZATION_ADMIN", "ORGANIZATION_INFORMATION_TECHNOLOGY_AUDITOR"]);

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return item.isDepartmentAdmin || item.isProcessAdmin || item.isOwner || hasValidRole;
    },
    onMemberSelect(item) {
      this.form = { ...this.form, admin: item };
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      if (this.form.parentCategory) {
        if (this.form.category) {
          delete this.form.parentCategory;
        } else {
          this.form.category = this.form.parentCategory;
        }
      }

      if (this.isEditMode) {
        try {
          const formData = JSON.parse(JSON.stringify(this.form));
          await this.$store.dispatch(`${state}/save`, this.form);

          // if (!this.initialPeriodicalStatus && formData.isPeriodical) {
          //   if (this.form.admin?._id == this.currentAccount._id) {
          //     this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${formData._id}/survey`);
          //   }
          // }
          this.$toast.success(this.$t("common.success"));
        } catch (error) {
          this.$handleHttpErrorByStatusCode(error);
        }
      }

      await this.$refs?.fileRocket?.uploadFiles();

      this.form = {};

      if (this.closeOnSave) {
        this.$root.$emit("bv::toggle::collapse", "sidebar-file-upload");
      }
    },

    async handleUploadResponse(event) {
      if (!this.isUploading) {
        if (event && event?.status !== 200) {
          this.$handleHttpErrorByStatusCode(event?.error || event);
        } else {
          // if (event.data?.isPeriodical || event.data?.approval?.path) {
          //   this.$store.commit("fileManager/selectedTab", 1);
          //   this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${event.data._id}/survey`);
          // }
          this.$toast.success(this.$t("common.success"));
          this.$root.$emit("bv::hide::modal", "file-manager-widget");
        }

        // await this.reloadWithId(this.form._id);
      }
    },
    async onParentCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationFileCategory/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage}`]: "asc" } },
        query: {
          name: { value },
          categoryDefinition: { value: { $nin: ["INVENTORY"] }, isObject: true },
          products: { value: { $in: this.form.products || [this.scope] || [] }, isObject: true },
          parent: { value: { $exists: false }, isObject: true },
        },
      });

      callback(response.data?.docs ?? []);
    },
    parentCategorySelect(item) {
      this.form = { ...this.form, parentCategory: item };
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationFileCategory/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage}`]: "asc" } },
        query: { name: { value }, products: { value: { $in: this.form.products || [] }, isObject: true }, parent: { value: this.form.parentCategory._id, isObject: true } },
      });
      callback(response.data?.docs ?? []);
    },
    categorySelect(item) {
      this.form = { ...this.form, category: item ? { _id: item._id, name: item.name } : undefined };
    },
  },
};
</script>

<style scoped>
.pcard--actions {
  display: flex;
  gap: 0.75rem;
  font-size: 1.5rem;
  margin-left: 0.75rem;

  i {
    cursor: pointer;
    transition: color 0.3s;
  }

  i:hover {
    color: #ff7c48;
  }
}
.disabled-pcard--actions {
  display: flex;
  gap: 0.75rem;
  font-size: 1.5rem;
  margin-left: 0.75rem;

  i {
    transition: color 0.3s;
    color: #7e7e7e;
  }
}

.add-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff7c48;
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
